import React, {useCallback, useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {api} from './Api.js';
import logo from '../logo.svg';

const Login = ({showNotification}) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [usernameError, setUsernameError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [waiting, setWaiting] = useState(false);
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  const signIn = useCallback(async (data) => {
    setWaiting(true);
    const response = await api.signIn(data, navigate, showNotification);
    if (api.isValidResponse(response)) navigate('/');
    else setError(true);
    setWaiting(false);
  }, [navigate, showNotification]);

  const onSubmit = useCallback((event) => {
    event.preventDefault();
    setError(false);
    setUsernameError('');
    setPasswordError('');
    if (!username) return setUsernameError('Enter your username');
    if (username.length < 4) return setUsernameError('Use at least 4 characters');
    if (!password) return setPasswordError('Enter your password');
    if (password.length < 4) return setPasswordError('Use at least 4 characters');
    signIn({username, password});
  }, [username, password, signIn]);

  return <main className="auth-page">
    <form className="auth-card surface-card" onSubmit={onSubmit} noValidate>
      <div className="auth-brand">
        <img src={logo} alt="anglisik"/>
        <span>anglisik</span>
      </div>
      <div className="auth-heading">
        <h1>Welcome back</h1>
        <p>Pick up where you left off.</p>
      </div>

      <div className="auth-fields">
        <label>
          <span className="field-label">Username</span>
          <input className="field-control" type="text" autoComplete="username" value={username} onChange={(event) => setUsername(event.target.value)} aria-invalid={Boolean(usernameError)}/>
          {usernameError && <span className="field-error">{usernameError}</span>}
        </label>
        <label>
          <span className="field-label">Password</span>
          <input className="field-control" type="password" autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)}
                 aria-invalid={Boolean(passwordError)}/>
          {passwordError && <span className="field-error">{passwordError}</span>}
        </label>
      </div>
      {error && <div className="form-alert" role="alert"><i className="material-icons" aria-hidden="true">error_outline</i> Sign-in failed. Check your details and try again.</div>}
      <button className="button-primary auth-submit" type="submit" disabled={waiting}>
        {waiting ? <><span className="loader-dot"/> Signing in…</> : <>Sign in <i className="material-icons" aria-hidden="true">arrow_forward</i></>}
      </button>
      <p className="auth-footer">New here? <Link to="/sign-up">Create an account</Link></p>
    </form>
  </main>;
};

export default Login;
